module.exports = __webpack_public_path__ + "img/downlod.f8f8740c.png";